/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setHeartRateMethodsOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getHrMethods() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const hrMethodsResponse = yield call([vitalsService, vitalsService.getHrMethods])
    const { entity } = hrMethodsResponse
    yield put(setHeartRateMethodsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getHrMethods() error: ${e}`))
  }
}

export function* getHrMethodsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getHrMethods)
}
